import { Shape, Vector2 } from 'three'

function perfil(pontos: [number, number][]) {
  return new Shape(pontos.map(([z, y]) => new Vector2(-z, y)))
}
const CASCA = perfil([
  [1.17, 0.97],
  [0.63, 1.55],
  [-0.7, 1.55],
  [-1.43, 0.97],
])
const VIDRO_FRENTE = perfil([
  [0.83, 1.06],
  [0.48, 1.44],
  [-0.14, 1.44],
  [-0.14, 1.06],
])
const VIDRO_TRAS = perfil([
  [-0.24, 1.06],
  [-0.24, 1.44],
  [-0.73, 1.44],
  [-1.2, 1.06],
])
const EXTRUSAO_CASCA = {
  depth: 1.62,
  bevelEnabled: true,
  bevelThickness: 0.025,
  bevelSize: 0.025,
  bevelSegments: 2,
  steps: 1,
}
const EXTRUSAO_VIDRO = { depth: 0.018, bevelEnabled: false, steps: 1 }

export function CabineCarro3D({ cor }: { cor: string }) {
  return (
    <group name="cabine-carro-perfil">
      <mesh position={[-0.81, 0, 0]} rotation={[0, Math.PI / 2, 0]} castShadow>
        <extrudeGeometry args={[CASCA, EXTRUSAO_CASCA]} />
        <meshStandardMaterial color={cor} metalness={0.25} roughness={0.4} />
      </mesh>
      <mesh position={[0, 1.255, 0.923]} rotation={[-0.7, 0, 0]}>
        <boxGeometry args={[1.47, 0.65, 0.028]} />
        <meshStandardMaterial
          color="#294451"
          metalness={0.4}
          roughness={0.13}
        />
      </mesh>
      <mesh position={[0, 1.27, -1.086]} rotation={[0.88, 0, 0]}>
        <boxGeometry args={[1.45, 0.63, 0.028]} />
        <meshStandardMaterial
          color="#294451"
          metalness={0.4}
          roughness={0.13}
        />
      </mesh>
      {[-1, 1].flatMap((lado) =>
        [VIDRO_FRENTE, VIDRO_TRAS].map((forma, i) => (
          <mesh
            key={`${lado}-${i}`}
            position={[lado < 0 ? -0.85 : 0.832, 0, 0]}
            rotation={[0, Math.PI / 2, 0]}
          >
            <extrudeGeometry args={[forma, EXTRUSAO_VIDRO]} />
            <meshStandardMaterial
              color="#294451"
              metalness={0.4}
              roughness={0.13}
            />
          </mesh>
        )),
      )}
    </group>
  )
}
